<ps-ui-card>
  <h6 psCardHeader>INCIDENCE</h6>
  <p psCardContent class="survey-status">
    <button class="stats-menu-btn" [psUiDropdownToggleFor]="Incidence">
      {{ content.incidenceLabel }}
    </button>
    <ps-ui-dropdown class="status-dropdown" #Incidence="psUiDropdown">
      <button
        psUiDropdownItem
        (click)="
          content.incidenceLabel = 'At Launch';
          content.incidenceValue = content.incidence.launch
        "
      >
        At Launch
      </button>
      <button
        psUiDropdownItem
        (click)="
          content.incidenceLabel = 'Overall';
          content.incidenceValue = content.incidence.overall
        "
      >
        Overall
      </button>
      <button
        psUiDropdownItem
        (click)="
          content.incidenceLabel = 'Recent';
          content.incidenceValue = content.incidence.recent
        "
      >
        Recent
      </button>
    </ps-ui-dropdown>
  </p>
  <p psCardFooter>{{ content.incidenceValue }} %</p>
</ps-ui-card>
